<template>
  <v-card :elevation="elevation" shaped>
    <v-row class="d-flex align-center justify-space-between">
      <v-col class="pb-0">
        <v-card-title>
          {{ title }}
        </v-card-title>
      </v-col>
      <v-col class="pb-0">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="d-flex align-center">
      <v-col class="pt-0">
        <v-card-subtitle v-if="subtitle">
          {{ subtitle }}
        </v-card-subtitle>
      </v-col>
    </v-row>
    <v-row v-if="!hideActions" class="d-flex align-center justify-space-between">
      <v-col class="pt-0 pl-10">
        <v-switch
          v-model="hideContingentWorkers"
          inset
          label="Hide Contingent Workers"
        ></v-switch>
      </v-col>
      <v-col class="pt-0">
        <v-switch
          v-model="hideNonManagers"
          inset
          label="Hide Non-Managers"
        ></v-switch>
      </v-col>
      <v-col class="shrink pt-0 pr-10">
        <v-btn rounded text>
          <v-icon left >mdi-cloud-download</v-icon>
          <vue-json-to-csv 
            :json-data="downloadData"
          ></vue-json-to-csv>
        </v-btn>
      </v-col>
    </v-row>
    <v-card-actions>
    </v-card-actions>
    <v-data-table
      :headers="computedHeaders"
      :items="computedEmployees"
      :search="search"
      :loading="loading"
      loading-text="Loading..."
    >
      <template v-slot:item.fields.Name="{ item }" >
        <router-link 
          :to="{ name: 'Employee', params: { id: item.id } }"
        >
        {{ item.fields.Name }}
        </router-link>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import VueJsonToCsv from 'vue-json-to-csv'
  import moment from 'moment'

  export default {
    name: 'EmployeeTable',
    props: {
      title: String,
      subtitle: String,
      hideActions: Boolean,
      employees: Array,
      headerProps: Array,
      elevation: Number
    },
    components: {
      VueJsonToCsv
    },
    data () {
      return {
        search: '',
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'fields.Name'
          }
        ],
        hideContingentWorkers: true,
        hideNonManagers: false
      }
    },
    computed: {
      computedEmployees () {
        let computedEmployees = this.employees
        if (this.hideContingentWorkers) {
          computedEmployees = computedEmployees.filter(e => {
            return e.fields['Is In ADP']
          })
        }
        if (this.hideNonManagers) {
          computedEmployees = computedEmployees.filter(e => {
            return e.fields['Has Direct Reports'] || e.fields['Manager Position'] === 'Yes'
          })
        }
        return computedEmployees
      },
      computedHeaders () {
        let newHeaders = this.headers
        if (this.headerProps) {
          newHeaders = newHeaders.concat(this.headerProps)
        }
        return newHeaders
      },
      downloadData () {
        return this.computedEmployees.map(e => {
          let mappedEmployee = {
            name: e.fields.Name
          }
          if (this.headerProps) {
            this.headerProps.forEach(prop => {
              let field = prop.value.split('fields.')[1]
              mappedEmployee[field] = e.fields[field]
            })
          }
          return mappedEmployee
        })
      },
      loading () {
        return this.employees.length === 0
      },
    },
    methods: {
      formatDatetime (session, field) {
        if (session.fields[field]) {
          return moment(session.fields[field])
                 .format("ddd, MMMM Do, YYYY h:mm a")
        } else {
          return 'TBD'
        }
      }
    }
  }
</script>
